export default {
    locale_code: 'da_DK',
    publication_viewer_shopping_list_label: 'Indkøbsliste',
    publication_viewer_shopping_list_clear_button: 'Ryd indkøbsliste',
    publication_viewer_delete_crossed_out_button: 'Slet overstregede varer',
    publication_viewer_print_button: 'Print',
    publication_viewer_download_button: 'Hent',
    publication_viewer_until_label: 'Til og med',
    publication_viewer_offer_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_menu_date_range: '{{{from}}} - {{{till}}}',
    publication_viewer_expires_in_days_label: '(Udløber om {{days}} dage)',
    publication_viewer_valid_in_days_label: '(Gælder om {{days}} dage)',
    publication_viewer_expired_label: '(Udløb)',
    publication_viewer_pages_button: 'Sider',
    publication_viewer_offers_button: 'Tilbud',
    publication_viewer_search_text: 'Søg',
    publication_viewer_currency: 'DKK',
    publication_viewer_hotspot_picker_header: 'Hvilket tilbud mente du?',
    publication_viewer_overview_button: 'Oversigt',
    publication_viewer_close_label: 'Tilbage',
    publication_viewer_add_to_shopping_list: 'Tilføj til indkøbsliste',
    publication_viewer_visit_webshop_link: 'Besøg webshoplink',
    publication_viewer_upcoming: 'Kommende',
    publication_viewer_offer_price_from: 'Fra',
    publication_viewer_offer_price_for: 'for',
    publication_viewer_offer_valid_from: 'Gælder kun fra d. ',
    publication_viewer_no_product_message: 'Ingen produkt detaljer',
    publication_viewer_offer_increase_quantity: 'Øg antal',
    publication_viewer_offer_decrease_quantity: 'Mindsk antal'
};
